import AdminBreadCrumb from "../components/AdminBreadCrumb";
import AdminLayout from "../components/AdminLayout"
import { useEffect, useState } from "react";
import $ from 'jquery';
import axios from "axios";
import { backendUrl } from "../data/Url";
const Newsletter = () => {
    const [newsletterData, setNewsletterData] = useState([]);
    useEffect(() => {

        const fetchData = async () => {
            try {
                const res = await axios.get(`${backendUrl}/admin/fetch-all-newsletter`);
                const arr = res.data;
                setNewsletterData(arr);
            } catch (error) {
                console.log(error)
            }
        }
        fetchData();

        $("#selectAll").on("change", function () {
            const isChecked = $(this).prop("checked");
            $(".admin-table tbody input[type=checkbox]").prop("checked", isChecked);
            setBtndisable(!isChecked);
        });
        $(".admin-table tbody input[type=checkbox]").on("change", function () {
            if (!$(this).prop("checked")) {
                $("#selectAll").prop("checked", false);
                if (!$(".admin-table tbody input[type=checkbox]").is(":checked")) {
                    setBtndisable(true);
                }
            } else {
                setBtndisable(false);
            }
        });
        var pageh = $(window).height();
        var ex = 65 + 49 + 100 + 38 + 16;
        var total = pageh - ex;
        $(".scroll").height(total + "px");
    }, [])
    
    const itemsPerPage = 20;
    const [currentPage, setCurrentPage] = useState(1);
    const [btndisable, setBtndisable] = useState(true);
    const totalPages = Math.ceil(newsletterData.length / itemsPerPage);
    const handleFirst = () => setCurrentPage(1);
    const handlePrev = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNext = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
    const handleLast = () => setCurrentPage(totalPages);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const currentPageData = newsletterData.slice(startIdx, startIdx + itemsPerPage);
    const [delId, setDelId] = useState("");
    const handleDelete = async (id) => {
        try {
            await axios.get(`${backendUrl}/admin/delete-newsletter/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <AdminLayout>
            <AdminBreadCrumb title="Newsletter"/>
            <div className="main-layout">
                <div className="container-fluid">
                    {
                        newsletterData.length !== 0 ?
                        <>
                        <div className="table-responsive scroll">
                            <table className="table table-hover table-striped admin-table">
                                <thead>
                                    <tr>
                                        <th>Sl No</th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <input type="checkbox" id="selectAll"/>
                                                <div className="dropdown">
                                                    <button class="btn p-0" style={{ position: "relative", top: "2px", color: "#fff", border: "none" }} type="button" data-bs-toggle="dropdown" aria-expanded="false" disabled={btndisable ? true : false}>
                                                        <i className='bx bx-chevron-down' ></i>
                                                    </button>
                                                    <ul class="dropdown-menu">
                                                        <li><button class="dropdown-item" type="button" data-bs-toggle="modal" data-bs-target="#bulkdeleteModal">Bulk Delete</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </th>
                                        <th>Action</th>
                                        <th>ID</th>
                                        <th>Email</th>
                                        <th>Ref ID</th>
                                        <th>IP</th>
                                        <th>Added</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentPageData.map((el, index) => {
                                            return (
                                                <tr key={el.ID}>
                                                    <td>{startIdx + index + 1}</td>
                                                    <td><input type="checkbox" id={`user${el.ID}`}/></td>
                                                    <td>
                                                        <button className="btn btn-danger" type="button" data-bs-toggle="modal" data-bs-target="#deleteNewsletterModal" onClick={() => setDelId(el.ID)}><i className='bx bxs-trash'></i></button>
                                                    </td>
                                                    <td>{el.ID}</td>
                                                    <td>{el.Email}</td>
                                                    <td>{el.RefUserID}</td>
                                                    <td>{el.IPAddress}</td>
                                                    <td>{el.AddedDate}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        {
                            newsletterData.length !== 0 ? 
                            <nav aria-label="...">
                            <ul class="pagination mb-0 mt-3 justify-content-end">
                                {
                                    currentPage > 1 && (
                                        <>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handleFirst}>First</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handlePrev}>Previous</button>
                                            </li>
                                        </>
                                    )
                                }
                                {
                                    Array.from({ length: totalPages }, (_, index) => (
                                        <li class={`page-item ${currentPage === index + 1 ? "active": ""}`} key={index}>
                                            <button class="page-link" onClick={() => setCurrentPage(index + 1)}>{index + 1}</button>
                                        </li>
                                    ))
                                }
                                {
                                    currentPage < totalPages && (
                                        <>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handleNext}>Next</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handleLast}>Last</button>
                                            </li>
                                        </>
                                    )
                                }
                            </ul>
                        </nav> : ""
                        }
                        </> : <p className="mb-0">No records found!</p>
                    }
                </div>
            </div>
            <div class="modal fade text-black" id="deleteNewsletterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Delete Newsletter</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            Are you sure to delete the newsletter ?
                        </div>
                        <div class="modal-footer" style={{ flexWrap: "nowrap" }}>
                            <button type="button" class="btn btn-default" style={{ width: "50%" }} data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger" style={{ width: "50%" }} onClick={() => handleDelete(delId)}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}

export default Newsletter;